import React from 'react';
import { Box } from '@mui/material';
import Social from './Social';

const SocialSettings = ({ defaultSettings, fetchSettings }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.social && (
        <Social
          settings={defaultSettings.social}
          fetchSettings={fetchSettings}
        />
      )}
    </Box>
  );
};

export default SocialSettings;
